import { default as home4pMUrBFKiHMeta } from "/opt/buildhome/repo/pages/home.vue?macro=true";
import { default as login4dfr6kRqBoMeta } from "/opt/buildhome/repo/pages/login.vue?macro=true";
import { default as _91environment_93QUqT9HxJ7mMeta } from "/opt/buildhome/repo/pages/master-data/restaurants/index/[environment].vue?macro=true";
import { default as index0FHWXVuy7fMeta } from "/opt/buildhome/repo/pages/master-data/restaurants/index.vue?macro=true";
import { default as index0u8gqLTZYOMeta } from "/opt/buildhome/repo/pages/master-data/tags/index.vue?macro=true";
import { default as _91environment_93Z9OozvhbrFMeta } from "/opt/buildhome/repo/pages/master-data/used-tags/index/[environment].vue?macro=true";
import { default as indexLgG1Ptbhl2Meta } from "/opt/buildhome/repo/pages/master-data/used-tags/index.vue?macro=true";
import { default as inventory_45sourceojvR2W7yBIMeta } from "/opt/buildhome/repo/pages/setting/inventory-source.vue?macro=true";
import { default as manage_45inventory_45source2WYKmH2X2dMeta } from "/opt/buildhome/repo/pages/setting/manage-inventory-source.vue?macro=true";
import { default as test_45case_45configv3XkNQfVdUMeta } from "/opt/buildhome/repo/pages/setting/test-case-config.vue?macro=true";
import { default as test_45case442Izgo35OMeta } from "/opt/buildhome/repo/pages/setting/test-case.vue?macro=true";
import { default as indexZXgGzQbCqFMeta } from "/opt/buildhome/repo/pages/setting/vendor-setting/index.vue?macro=true";
export default [
  {
    name: "home",
    path: "/home",
    component: () => import("/opt/buildhome/repo/pages/home.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: login4dfr6kRqBoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "master-data-restaurants",
    path: "/master-data/restaurants",
    component: () => import("/opt/buildhome/repo/pages/master-data/restaurants/index.vue"),
    children: [
  {
    name: "master-data-restaurants-index-environment",
    path: ":environment()",
    component: () => import("/opt/buildhome/repo/pages/master-data/restaurants/index/[environment].vue")
  }
]
  },
  {
    name: "master-data-tags",
    path: "/master-data/tags",
    component: () => import("/opt/buildhome/repo/pages/master-data/tags/index.vue")
  },
  {
    name: "master-data-used-tags",
    path: "/master-data/used-tags",
    component: () => import("/opt/buildhome/repo/pages/master-data/used-tags/index.vue"),
    children: [
  {
    name: "master-data-used-tags-index-environment",
    path: ":environment()",
    component: () => import("/opt/buildhome/repo/pages/master-data/used-tags/index/[environment].vue")
  }
]
  },
  {
    name: "setting-inventory-source",
    path: "/setting/inventory-source",
    component: () => import("/opt/buildhome/repo/pages/setting/inventory-source.vue")
  },
  {
    name: "setting-manage-inventory-source",
    path: "/setting/manage-inventory-source",
    component: () => import("/opt/buildhome/repo/pages/setting/manage-inventory-source.vue")
  },
  {
    name: "setting-test-case-config",
    path: "/setting/test-case-config",
    component: () => import("/opt/buildhome/repo/pages/setting/test-case-config.vue")
  },
  {
    name: "setting-test-case",
    path: "/setting/test-case",
    component: () => import("/opt/buildhome/repo/pages/setting/test-case.vue")
  },
  {
    name: "setting-vendor-setting",
    path: "/setting/vendor-setting",
    component: () => import("/opt/buildhome/repo/pages/setting/vendor-setting/index.vue")
  }
]